import type { ButtonBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface ButtonBlockEditorProps {
  content: ButtonBlockContent | null
  onChange: (content: ButtonBlockContent) => void
}

export function ButtonBlockEditor({ content, onChange }: ButtonBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<ButtonBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Button</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Text</Label>
          <Input
            value={c.text ?? ""}
            onChange={(e) => update({ text: e.target.value })}
            placeholder="Learn more"
          />
        </div>
        <div>
          <Label>URL</Label>
          <Input
            value={c.url ?? ""}
            onChange={(e) => update({ url: e.target.value })}
            placeholder="https://..."
          />
        </div>
        <div>
          <Label>Variant</Label>
          <Select
            value={c.variant ?? "primary"}
            onValueChange={(v) =>
              update({ variant: v as "primary" | "secondary" | "outline" })
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="primary">Primary</SelectItem>
              <SelectItem value="secondary">Secondary</SelectItem>
              <SelectItem value="outline">Outline</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>Align</Label>
          <Select
            value={c.align ?? "left"}
            onValueChange={(v) =>
              update({ align: v as "left" | "center" | "right" })
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="left">Left</SelectItem>
              <SelectItem value="center">Center</SelectItem>
              <SelectItem value="right">Right</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  )
}
